export default __webpack_public_path__ + "static/media/SolmazPic.1a4b234a.jpeg";